<template>
    <main class="main">
        <categories-menu />
        <div
            v-for="(category, i) in categories"
            :key="i"
            class="accordion_section"
        >
            <v-container>
                <v-layout column>
                    <v-flex>
                        <section :id="`category_${category.id}`" class="v-card v-card--flat v-sheet v-sheet--tile theme--light">
                            <h2 class="v-card__title">{{ category.title }}</h2>
                            <v-row v-if="category.subcategories !== null" justify="center">
                                <v-expansion-panels accordion>
                                    <v-expansion-panel
                                        v-for="(subcategory, i) in category.subcategories"
                                        :key="i"
                                    >
                                        <v-expansion-panel-header disable-icon-rotate>
                                            {{ subcategory.title }}
                                            <template v-slot:actions>
                                                <v-icon color="#36cefc" class="accordion--plus">mdi-plus</v-icon>
                                                <v-icon color="#36cefc" class="accordion--minus">mdi-minus</v-icon>
                                            </template>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <questions-category-list
                                                :category-id="category.id"
                                                :subcategory-id="subcategory.id"
                                            />
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-row>
                        </section>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
    </main>
</template>

<script>

import CategoriesMenu from '~/components/molecules/CategoriesMenu'
import QuestionsCategoryList from '~/components/atoms/QuestionsCategoryList'
export default {
    name: 'Faq',
    components: {
        QuestionsCategoryList,
        CategoriesMenu
    },
    data: () => ({
        questions: [
            {
                id: 0,
                title: 'Question 0'
            },
            {
                id: 1,
                title: 'Question 1'
            },
            {
                id: 2,
                title: 'Question 2'
            }
        ]
    }),

    computed: {
        categories () {
            console.info('getCategoryL1ById', this.$store.getters.getCategories)
            return this.$store.getters.getCategories
        }
    }
}
</script>
